export enum UserType {
  student = 1,
  teacher = 2,
  manager = 4,
}
